import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const bgColors = [
    'bg-secondary-50', 'bg-accent-50', 'bg-background-100', 'bg-secondary-100',
    'bg-accent-100', 'bg-background-200/50', 'bg-secondary-200/50', 'bg-accent-200/50',
    'bg-secondary-50', 'bg-accent-50', 'bg-background-200/50', 'bg-secondary-100',
    'bg-accent-100', 'bg-background-100',
  ];

  return (
    <section id="categories" className="py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-foreground-500 mb-4">
              Shop by Category
            </p>
            <h2 className="text-[40px] md:text-[56px] font-heading text-foreground-950 leading-[1.05]">
              Browse Our<br />
              <span className="italic font-normal text-foreground-600">Complete Collection</span>
            </h2>
          </div>
          <p className="text-[13px] text-foreground-600 max-w-[340px] leading-relaxed">
            Explore all 14 product categories organized in the itaobuy spreadsheet.
            Each category links directly to the structured comparison view.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {categories.map((cat, index) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group block rounded-2xl overflow-hidden ${bgColors[index]} transition-transform hover:-translate-y-1 cursor-pointer`}
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="px-5 py-4 bg-white">
                <h3 className="text-[14px] font-semibold text-foreground-950">{cat.name}</h3>
                <p className="text-[11px] text-foreground-500 mt-1">View on Kas</p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-secondary-100 text-secondary-900 text-[13px] font-semibold hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Categories on Spreadsheet
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}